/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { twMerge } from 'utilities/src/twMerge';

import IconComponent from 'ui/src/components/Icon';

import { MobileMenuItemProps } from './_props';
import MobileMenuLinks from './MobileMenuLinks';
import useHeader from '../header/hooks/useHeader';
import MobileMenuItemWrapper from './MobileMenuItemWrapper';

function MobileMenuItem({ menuItem }: MobileMenuItemProps) {
  const { toggleMobileMenuActiveItem, mobileMenuActiveItem } = useHeader();

  const handleClick = () => {
    toggleMobileMenuActiveItem(menuItem.id);
  };

  return (
    <li className={twMerge('flex flex-col items-start justify-center gap-6 overflow-y-auto py-4')}>
      <MobileMenuItemWrapper
        className="site-paragraph-m flex w-full items-center gap-1 pl-8 font-bold hover:underline"
        onClick={handleClick}
        item={menuItem}
      >
        {menuItem.title}

        {menuItem.sections.length > 0 && (
          <IconComponent
            iconName="ExpandMore"
            size="IconS"
            className={twMerge(
              'bg-site-neutrals-800 transition duration-200',
              menuItem.id === mobileMenuActiveItem ? 'rotate-180' : '',
            )}
          />
        )}
      </MobileMenuItemWrapper>

      <MobileMenuLinks subMenuItem={menuItem} />
    </li>
  );
}

export default MobileMenuItem;
